export interface DeviceLiveState {
  locked?: boolean | null;
  dpsOpen?: boolean | null;
  relayOpen?: boolean | null;
  communicationLost?: boolean | null;
  rexOn?: boolean | null;
  alarm?: boolean | null;
  battery_pct?: number | null;
  features?: string[];
  firmware_version?: string | null;
  fetched_at?: string;
  observed_at?: string;
  unavailable_reason?: string | null;
  streamReady?: boolean | null;
}

/** Adapt the existing `/devices/:id/status` contract for the detail modal. */
export function adaptDeviceStatusResponse(payload: Record<string, any>, fetchedAt = new Date().toISOString()): DeviceLiveState {
  const online = typeof payload.online === 'boolean'
    ? payload.online
    : String(payload.connection_status || '').toLowerCase() === 'online';
  return {
    communicationLost: !online,
    locked: typeof payload.locked === 'boolean'
      ? payload.locked
      : typeof payload.lock_status === 'string'
        ? payload.lock_status.toLowerCase() === 'locked'
        : null,
    dpsOpen: typeof payload.dpsOpen === 'boolean' ? payload.dpsOpen
      : typeof payload.door_open === 'boolean' ? payload.door_open : null,
    relayOpen: typeof payload.relayOpen === 'boolean' ? payload.relayOpen
      : typeof payload.relay_open === 'boolean' ? payload.relay_open : null,
    rexOn: typeof payload.rexOn === 'boolean' ? payload.rexOn
      : typeof payload.rex_on === 'boolean' ? payload.rex_on : null,
    alarm: typeof payload.alarm === 'boolean' ? payload.alarm
      : typeof payload.alarm_active === 'boolean' ? payload.alarm_active : null,
    battery_pct: payload.battery_pct ?? payload.battery_percent ?? null,
    features: Array.isArray(payload.features) ? payload.features : [],
    firmware_version: payload.firmware_version || null,
    fetched_at: fetchedAt,
    observed_at: payload.last_seen || payload.last_seen_at || null,
    unavailable_reason: payload.integration_error || null,
    streamReady: typeof payload.stream_ready === 'boolean' ? payload.stream_ready : null,
  };
}
